import { default as FilterableCommandBarItem } from "sh-application/components/commandbar/FilterableCommandBarItem";
import { GlobalCommandBarViewState } from "../schema/GlobalCommandBarViewState";
import { mutatorAction } from "satcheljs";

export default mutatorAction("SET_GLOBAL_COMMANDBAR_RIGHT_ITEMS",
    function setGlobalCommandBarRightItems(
        viewState: GlobalCommandBarViewState,
        rightItems: FilterableCommandBarItem[]) {
        viewState.rightCommandBarItems = rightItems;
    });